import React, { useState } from 'react';
import { type WifiNetwork } from '@lib/networkApiTypes';
import { useWifiNetworks } from '@src/contexts';
import { WifiConnection, WifiDisconnection } from './wifi_connection';
import { WifiSelection } from './wifi_selection';

interface WifiOnboardingContentProps {
  onSkipWifiSelection: () => void
  onWifiOnboardingComplete: () => void
}

export const WifiOnboardingContent = ({ onSkipWifiSelection, onWifiOnboardingComplete }: WifiOnboardingContentProps): JSX.Element => {
  const { connectedWifiNetwork } = useWifiNetworks();
  const [selectedWifiNetwork, setSelectedWifiNetwork] = useState<WifiNetwork | undefined>(undefined);

  if (selectedWifiNetwork === undefined) {
    return <WifiSelection
      onSkipWifiSelection={onSkipWifiSelection}
      onWifiSelected={setSelectedWifiNetwork}
    />;
  }

  if (selectedWifiNetwork.ssid === connectedWifiNetwork?.ssid) {
    return <WifiDisconnection
      wifiNetwork={connectedWifiNetwork}
      onCancel={() => { setSelectedWifiNetwork(undefined); }}
    />;
  }

  return <WifiConnection
    wifiNetwork={selectedWifiNetwork}
    onCancel={() => { setSelectedWifiNetwork(undefined); }}
    onWifiConnected={onWifiOnboardingComplete}
  />;
};
